import { KeyValuePair } from '@app/core/models/keyValuePair';

class FixedDoorPositions {
  None = { key: 0, value: 'Geen' };
  Left = { key: 1, value: 'Links' };
  Right = { key: 2, value: 'Rechts' };
  Both = { key: 3, value: 'Beide' };
  FixedDoor = { key: 4, value: 'Alleen VD' };
}
const fixedDoorPositions = new FixedDoorPositions();
const keyValuePairs: Array<KeyValuePair> = [
    fixedDoorPositions.None,
    fixedDoorPositions.Left,
    fixedDoorPositions.Right,
    fixedDoorPositions.Both,
    fixedDoorPositions.FixedDoor
];

export {
    fixedDoorPositions,
    keyValuePairs
};
